"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var browser_logs_1 = require("@datadog/browser-logs");
function LogCollector(_a) {
    var _b = _a.clientToken, clientToken = _b === void 0 ? "pub1756e518d48c02e34a9aba48fa814199" : _b, children = _a.children, _c = _a.forceLogging, forceLogging = _c === void 0 ? false : _c, _d = _a.datacenter, datacenter = _d === void 0 ? browser_logs_1.Datacenter.US : _d;
    var host = window.location.hostname.split(".").shift();
    react_1.useEffect(function () {
        if (clientToken) {
            if (process.env.NODE_ENV === "production" || forceLogging) {
                // eslint-disable-next-line no-console
                console.info("LogCollector is active.");
                browser_logs_1.datadogLogs.init({
                    clientToken: clientToken,
                    forwardErrorsToLogs: true,
                    sampleRate: 100,
                    datacenter: datacenter,
                });
                browser_logs_1.datadogLogs.addLoggerGlobalContext("host", host);
                browser_logs_1.datadogLogs.addLoggerGlobalContext("service", "apps");
            }
            else {
                // eslint-disable-next-line no-console
                console.info("LogCollector is not active in a non-production environment.");
            }
        }
        else {
            // eslint-disable-next-line no-console
            console.error("LogCollector is mounted, but no client token provided!");
        }
    }, []);
    return react_1.default.createElement(react_1.default.Fragment, null, children);
}
exports.default = LogCollector;
//# sourceMappingURL=LogCollector.js.map